module.exports = __webpack_public_path__ + "static/sports-79837989c1cee432c86f8defb8cd8ebf.png";